import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setting, form, permissions as permissionDeco } from 'helpers/decorators'
import { Checkbox } from 'components/fields'
import { Row, Col, SettingActions } from 'components/misc'
import { messages as messagesApi } from 'redux/modules/api'
import { compose } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import styles from './setting-messages.styl'
import PropTypes from 'prop-types'
import { get } from 'lodash'


const enhance = compose(
    injectIntl,
    permissionDeco(),
    connect(
        ({ api, auth, form }) => ({
            settings: api.messages.settings,
          count: api.messages.count,
          activeOrganization: auth.organization,
          forms: form
        }),
        { setSettings: messagesApi.setSettings }
    ),
    setting({
      form: 'messages-settings',
      persist: true
    })
)

class SettingMessages extends Component {
  static propTypes = {
    forms: PropTypes.object,
    reset: PropTypes.func,
    setSettings: PropTypes.func
  }

  handleSetFilter = () => {
    this.props.reset()
    this.props.setSettings()
  }


  render() {
    const { forms } = this.props

    const isGrouped = get(forms, 'messages-settings.values.isGrouped')

    const isGroupedByTypes = get(forms, 'messages-settings.values.isGroupedByTypes')


    return (
        <div  className={styles.messageSettingsWrapper}>
            <h2><FormattedMessage id='moduleTitle.additional_settings' defaultMessage='Additional Settings' /></h2>

        <div style={{ marginTop: '-40px' }}>
            <Row
                alignItems="center"
                gutters inner
            >
                <Col flex="0 1 200px">
                    <div>
                    <Checkbox
                        label="Group messages"
                        intlKey="label.group_messages"
                        name="isGrouped"
                        disabled={isGroupedByTypes}
                        onChange={() => this.handleSetFilter()}
                        justify
                    />
                    </div>
                </Col>
              <Col flex="0 1 200px">
                <div>
                  <Checkbox
                    label="Group messages by channel"
                    intlKey="label.group_messages_by_channel"
                    name="isGroupedByTypes"
                    disabled={isGrouped}
                    onChange={() => this.handleSetFilter()}
                    justify
                  />
                </div>
              </Col>
                <Col flex="1 1 auto" alignSelf="flex-end" right>
                    <SettingActions {...this.props} />
                </Col>
            </Row>
          </div>
        </div>

    )
  }
}


export default enhance(SettingMessages)
